import { render } from "./RedBookPage.vue?vue&type=template&id=51835765&scoped=true"
import script from "./RedBookPage.vue?vue&type=script&lang=js"
export * from "./RedBookPage.vue?vue&type=script&lang=js"

import "./RedBookPage.vue?vue&type=style&index=0&id=51835765&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51835765"]])

export default __exports__